import { takeLatest, put, call } from 'redux-saga/effects';
import { FETCH_ERRORS, CLEAR_ERRORS } from '../error/types';
import { STATUS } from '../../config/constants/states';
import {
  DOWNLOAD_EXCEL
} from './types';
import {
  downloadDocExcel
} from '../../network/download/index';

function* getExcel(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(downloadDocExcel, payload.params);
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* watchDownloadExcel() {
  yield takeLatest(DOWNLOAD_EXCEL, getExcel);
}

export default [
  watchDownloadExcel(),
];
